import * as yup from "yup";

const selectSchema = (error: string) =>
  yup.string().test("selectError", error, (value) => value !== "0");

export default selectSchema;
